import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import adImage1 from "../../images/ad1.png";
import adImage2 from "../../images/ad2.png";
import adImageM1 from "../../images/ad_m1.png";
import adImageM2 from "../../images/ad_m2.png";
import { Link } from "react-router-dom";

const products = [
  { id: 1, name: "Product 1", image: adImage1, imageM: adImageM1 },
  { id: 2, name: "Product 2", image: adImage2, imageM: adImageM2 },
];

const AdvertiseProduct = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="relative overflow-hidden">
      <Slider {...settings}>
        {products.map((product) => (
          <div
            key={product.id}
            className="relative h-full overflow-hidden mt-16"
          >
            <div className="hidden md:block">
              <Link to="/allproduct/allproduct">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover "
                />
              </Link>
            </div>
            <div className="md:hidden">
              <Link to="/allproduct/allproduct">
                <img
                  src={product.imageM}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default AdvertiseProduct;
